export default {
  generateTree: function (
    parentId,
    list,
    parentField = "parentId",
    idField = "id"
  ) {
    if (list.length == 0) {
      return [];
    }
    let filterList = list.filter((value) => value[parentField] == parentId);
    let tree = filterList;
    list = list.filter((value) => value[parentField] != parentId);
    for (let i = 0, len = tree.length; i < len; i++) {
      tree[i].children = this.generateTree(
        tree[i][idField],
        list,
        parentField,
        idField
      );
    }
    return tree;
  },
  generateTreeSmart: function (list, parentField = "parentId", idField = "id") {
    let idSet = {};
    let parentIdSet = {};
    for (let i = 0, len = list.length; i < len; i++) {
      const node = list[i];
      idSet[node[idField]] = true;
      parentIdSet[node[parentField]] = true;
    }

    let tree = [];
    for (let i = 0, len = list.length; i < len; i++) {
      const node = list[i];
      if (!idSet[node[parentField]]) {
        node.children = this.generateTree(
          node[idField],
          list,
          parentField,
          idField
        );
        tree.push(node);
      }
    }
    return tree;
  },
  getListFromTree: function (list, tree) {
    if (list == null) {
      list = [];
    }
    if (!tree || !tree.length || tree.length == 0) {
      return;
    }
    for (let i = 0, len = tree.length; i < len; i++) {
      this.getListFromTree(list, tree[i].children);
      tree[i].children = [];
      list.push(tree[i]);
    }
  },
};
